// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Settings from 'church-theme-library/components/svg/editor/settings-b.svg'
import Add from 'church-theme-library/components/svg/editor/plus.svg'
import Close from 'church-theme-library/components/svg/editor/close.svg'
import ArrowsV from 'church-theme-library/components/svg/editor/arrows-v-short.svg'

class PageSectionEditorUI extends React.Component {
	render() {
		const { userCanEditPage, pageId, pageType, id, sectionId, sectionData, prevItemKey, allSections, isFirst } = this.props

		if ( ! userCanEditPage ) {
			return null
		}

		const allSectionsJson = JSON.stringify( allSections )

		return (
			<div className="dke-standard-page-section-ui">
				<div className="dke-page-section-ui-inner">
					{ sectionData && sectionData.settings &&
						<div className="dke-page-section-settings"
							data-is-section-settings="1"
							data-parent-type={ pageType }
							data-parent-id={ pageId }
							data-content-id={ id }
							data-section-id={ sectionId }
							data-section-type={ sectionData.type }
							data-section-settings={ JSON.stringify( sectionData.settings ) }
						>
							<div className="-svg">
								<Settings />
							</div>

							<div className="-beacon">
								<div className="dke-theme-beacon" data-id="section_settings"></div>
							</div>
						</div>
					}

					<div className="dke-page-section-add"
						data-is-section-add="1"
						data-previous-id={ prevItemKey || '' }
						data-parent-type={ pageType }
						data-parent-id={ pageId }
						data-content-id={ id }
					>
						<div className="-svg">
							<Add />
						</div>

						<div className="-beacon">
							<div className="dke-theme-beacon" data-id="section_add"></div>
						</div>
					</div>

					{ ! isFirst &&
						<div className="dke-page-section-remove"
							data-is-section-remove="1"
							data-parent-type={ pageType }
							data-parent-id={ pageId }
							data-content-id={ id }
							data-section-id={ prevItemKey || '' }
						>
							<div className="-svg">
								<Close />
							</div>

							<div className="-beacon">
								<div className="dke-theme-beacon" data-id="section_remove"></div>
							</div>
						</div>
					}

					{ ! isFirst &&
						<div className="dke-page-section-order"
							data-is-section-order="1"
							data-parent-type={ pageType }
							data-parent-id={ pageId }
							data-content-id={ id }
							data-all-sections={ allSectionsJson }
						>
							<div className="-svg">
								<ArrowsV />
							</div>

							<div className="-beacon">
								<div className="dke-theme-beacon" data-id="section_order"></div>
							</div>
						</div>
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	let selected = state.page.selected,
		// userCanEditPage = selected && selected.user_can_edit ? selected.user_can_edit : false,
		userCanEditPage = siteData.current_user_can_edit_pages,
		pageId = selected && selected.id ? selected.id : false,
		pageType = selected && selected.type ? selected.type : false

	return {
		allMetaData: state.content.metaData,
		userCanEditPage: userCanEditPage,
		pageId: pageId,
		pageType: pageType
	}
}

export default connect( mapStateToProps )( PageSectionEditorUI )
